import type { CallbackInterface } from 'recoil'

import { importState } from 'Pages/ImportFattureInCloud/recoil/state'

import { pageState } from 'State/page'

import type { PageStateType } from 'Types/state'

import { logAppError } from 'Helpers/logger'

import getIntl from 'Helpers/intl'

import {
  fetchConnectionStatus,
  handleImport,
  importClients,
} from 'Pages/ImportFattureInCloud/recoil/services'
import { notifyDisconnected } from 'Pages/ImportFattureInCloud/recoil/toasts'

export const initPageCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    set<PageStateType>(pageState, (prev) => ({ ...prev, loading: true }))

    try {
      const status = await fetchConnectionStatus()

      if (status === 'CONNECTED') {
        set(importState, (prev) => ({ ...prev, loading: true }))
        set<PageStateType>(pageState, (prev) => ({ ...prev, status: 'ready' }))

        const [_status, fileName] = await importClients()

        if (_status === 'CONNECTED') {
          handleImport(fileName)
        } else {
          notifyDisconnected()
        }
      } else {
        notifyDisconnected()
      }
    } catch (error) {
      console.error('### error', error)

      logAppError({
        Component: 'ImportFattureInCloud',
        Method: 'initPageCallback',
        appError: error,
      })
      set<PageStateType>(pageState, (prev) => ({
        ...prev,
        status: 'error',
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
      }))
    }

    set<PageStateType>(pageState, (prev) => ({ ...prev, loading: false }))
  }

export const resetPageCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(importState)
  }
